import { render, staticRenderFns } from "./NewAgent.vue?vue&type=template&id=dd023f94"
import script from "./NewAgent.vue?vue&type=script&lang=js"
export * from "./NewAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports